import UTMPurser from "./purser/index";
import PageViews from "./purser/PageViews";
import getTrackingCookieValue from "./utils/getTrackingCookieValue";

// These imports are local imports. It's NOT a npm package. They live in
// the gatsby-plugin-marketo folder. It's based on Purser, which can be found here:
// https://github.com/bilbof/purser

export const onInitialClientRender = () => {
    // Collect UTM and/or create PURSER Local storage object,
    // or add to it if it exists. If it has been longer than
    // 30 minutes. It will count as a new "visit". Only fires when
    // the end user first gets to the site.
    UTMPurser.init();

    // If a utm_team is not yet present, add it to the Purser object
    if (!UTMPurser.get().utm_team) {
        UTMPurser.save({
            utm_team: "WEB",
        });
    }
};

export const onRouteUpdate = () => {
    // Collect Pageviews on route updates
    PageViews.add();

    // Cross-domain Marketo token tracking
    // Sets a cookie based on a _mkto_trk query string parameter
    // Get existing URL params
    const urlParams = new URLSearchParams(window.location.search);

    // If a form page scroll the form into view after submit
    if (urlParams.get("ty")) {
        const form = document.querySelector(".formHolder");
        if (form) {
            form.scrollIntoView();
        }
    }

    // Find the _mkto_trk param
    const mktoCookie = urlParams.get("_mkto_trk");

    // Set a cookie if the _mkto_trk param exists
    if (mktoCookie) {
        document.cookie = `_mkto_trk=${mktoCookie};path=/`;
    }

    // Array of associated domains, derived from an environment variable
    const associatedDomains = process.env.GATSBY_MARKETO_CROSS_TRACKING_DOMAINS
        ? process.env.GATSBY_MARKETO_CROSS_TRACKING_DOMAINS.split(" ")
        : false;

    // Get the Marketo Tracking params ("_mkto_trk") value
    const cookieValue = getTrackingCookieValue("_mkto_trk");

    if (cookieValue && associatedDomains) {
        // Loop through the associated domains and add the tracking string to the end of the URL
        associatedDomains.forEach((domain) => {
            // Get any links on the page that match the associated domain
            const assocLinks = document.querySelectorAll(`a[href*='${domain}']`);

            // For each link, add the tracking string to the "search parameters" of the URL
            [...assocLinks].map((link) => {
                const url = new URL(link.href);
                url.searchParams.append("_mkto_trk", cookieValue);
                return (link.href = url.href);
            });
        });
    }
};
